/**
 * useInvoiceCalculations Hook
 * Fatura hesaplama işlemlerini yönetir
 */

import { useMemo } from 'react';
import { InvoiceItem } from '../components/types/invoice.types';
import {
  calculateTotals,
  calculateTevkifat,
  calculateStopaj,
} from '../utils/invoiceCalculations';

interface UseInvoiceCalculationsProps {
  items: InvoiceItem[];
  tevkifatRate: string;
  stopajRate: number;
}

export const useInvoiceCalculations = ({
  items,
  tevkifatRate,
  stopajRate,
}: UseInvoiceCalculationsProps) => {
  // Ara toplamları hesapla
  const totals = useMemo(() => calculateTotals(items), [items]);

  // Tevkifat tutarını hesapla
  const tevkifatAmount = useMemo(
    () => calculateTevkifat(totals.vatTotal, tevkifatRate),
    [totals.vatTotal, tevkifatRate]
  );

  // Stopaj tutarını hesapla
  // ⚠️ GV stopajı KDV HARİÇ matrah (KDV matrahı) üzerinden hesaplanır, brüt toplam üzerinden DEĞİL.
  const stopajAmount = useMemo(
    () => calculateStopaj(totals.netSubtotal, stopajRate),
    [totals.netSubtotal, stopajRate]
  );

  // Net ödenecek tutar (tevkifat ve stopaj düşülmüş)
  const payableAmount = useMemo(() => {
    return totals.grandTotal - tevkifatAmount - stopajAmount;
  }, [totals.grandTotal, tevkifatAmount, stopajAmount]);

  return {
    // Ara toplamlar
    subtotal: totals.subtotal,
    netSubtotal: totals.netSubtotal, // İndirim sonrası ara toplam (KDV hariç)
    discountNetTotal: totals.discountNetTotal, // KDV hariç matrah indirimi (özet için)
    vatTotal: totals.vatTotal,
    sctTotal: totals.sctTotal,
    discountTotal: totals.discountTotal,
    grandTotal: totals.grandTotal,
    vatRateTotals: totals.vatRateTotals,

    // Kesintiler
    tevkifatAmount,
    stopajAmount,

    // Net tutar
    payableAmount,
  };
};

